'use strict';

export default class LangController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
  }

  $onInit() {
    this.getCount()
  }

  getCount() {
    this.$http.get('/api/firmware/modelStatistics').then(res => {
      this.data = res.data;
    });
  }

  search(model) {
    this.$http.get(`/api/firmware/modelStatistics?model=${model}`).then(res => {
      this.data = res.data;
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/firmwares/model/model.controller.js